import * as React from 'react';
import Section from '../../components/Section';
import { Text, Select, NumberField } from '../../components/forms';
import { grindSizes, Guide, GuideDose } from '../../guide';

export interface Props {
  guide: Guide;
  onChange: Function;
  dose: GuideDose;
  onDoseChange: Function;
}

const setValue = (props: Props) => (field: string, newValue: String) =>
  props.onChange(
    Object.assign({}, props.guide, {
      [field]: newValue,
    }),
  );

const setDoseValue = (props: Props) => (field: string, newValue: String) =>
  props.onDoseChange(
    Object.assign({}, props.dose, {
      [field]: newValue,
    }),
  );

export const Dose = (props: Props) => (
  <React.Fragment>
    <Section title="Coffee">
      <div className="flex flex-column flex-row-l">
        <div className="pa3 tc w-30-l w-100">
          <img
            className="br-100 w3 h3 h4-ns w4-ns dib"
            src="/images/steps/grind.png"
            alt="Coffee Dose"
          />
        </div>
        <div className="pa3 w-70-l w-100">
          <Text
            label="Coffee (G)"
            field={['coffee']}
            id="coffee"
            defaultValue={props.dose.coffee}
            onValueChange={setDoseValue(props)}
          />
          <Select
            label="Grind Size"
            field={['grind_size']}
            id="grind_size"
            options={grindSizes}
            defaultValue={props.guide.grind_size}
            onValueChange={setValue(props)}
          />
        </div>
      </div>
    </Section>
    <Section title="Water">
      <div className="flex flex-column flex-row-l">
        <div className="pa3 tc w-30-l w-100">
          <img
            className="br-100 w3 h3 h4-ns w4-ns dib"
            src="/images/steps/boil.png"
            alt="Water Dose"
          />
        </div>
        <div className="pa3 w-70-l w-100">
          <Text
            label="Water (Ml)"
            field={['water']}
            id="water"
            defaultValue={props.dose.water}
            onValueChange={setDoseValue(props)}
          />
          <NumberField
            label="Temperature (°C)"
            field={['temperature']}
            id="temperature"
            defaultValue={props.guide.temperature}
            onValueChange={setValue(props)}
          />
        </div>
      </div>
    </Section>
  </React.Fragment>
);

export default Dose;
